import React from "react"
import {
  Wrapper,
  TimelineElement,
  TimelineContainer,
  Text,
  Dot,
  Line,
} from "./styles"


const Timeline = ({onClick}) => {
  const data = [
    { content: "1939 - 1949" },
    { content: "1950 - 1969" },
    { content: "1970 - 1979" },
    { content: "1990 - 1989" },
    { content: "1990 - 1999" },
    { content: "1999 - 2005" },
  ]

  return (
    // <Wrapper>
      <TimelineContainer>
        <Line />
        {data.map((item, index) => (
          <TimelineElement onClick={() => onClick(index)} delay={index} key={index}>
            <Text>{item.content}</Text>
            <Dot />
          </TimelineElement>
        ))}
      </TimelineContainer>
    // </Wrapper>
  )
}

export { Timeline }
